import { render, staticRenderFns } from "./Separate.vue?vue&type=template&id=97cf8406&"
import script from "./Separate.vue?vue&type=script&lang=js&"
export * from "./Separate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports